'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-redux-sweetalert/~/react-redux/~/react/react.js
// module id = ./node_modules/react-redux-sweetalert/node_modules/react-redux/node_modules/react/react.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons